'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Uniform = require('../Uniform');

var _Close = require('../shared/icons/Close');

var _Close2 = _interopRequireDefault(_Close);

var _Trash = require('../shared/icons/Trash');

var _Trash2 = _interopRequireDefault(_Trash);

require('./_confirm-dismiss-feed-item.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ConfirmDismissFeedItem = function (_React$Component) {
  _inherits(ConfirmDismissFeedItem, _React$Component);

  function ConfirmDismissFeedItem() {
    _classCallCheck(this, ConfirmDismissFeedItem);

    return _possibleConstructorReturn(this, (ConfirmDismissFeedItem.__proto__ || Object.getPrototypeOf(ConfirmDismissFeedItem)).apply(this, arguments));
  }

  _createClass(ConfirmDismissFeedItem, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var feedItem = this.props.feedItem;

      var status = void 0;
      if (feedItem.isRequesting) {
        status = 'spinning';
      } else if (feedItem.isError) {
        status = 'failure';
      } else {
        status = null;
      }

      var trashIcon = _react2.default.createElement(_Trash2.default, { className: 'uni-btn__icon trash-icon' });

      var body = feedItem.isError ? _react2.default.createElement(
        'div',
        { className: 'feed-modal-content' },
        _react2.default.createElement(
          'p',
          null,
          'Unable to delete this post. Please try again later.'
        )
      ) : _react2.default.createElement(
        'div',
        { className: 'feed-modal-content' },
        _react2.default.createElement(
          'p',
          null,
          'Warning: This cannot be undone.'
        ),
        _react2.default.createElement(
          'p',
          null,
          'You are about to permanently remove this post from your timeline.'
        ),
        _react2.default.createElement(
          'p',
          null,
          'Are you sure you want to remove it?'
        )
      );

      return _react2.default.createElement(
        'div',
        { className: 'dismiss-feed-item-modal' },
        _react2.default.createElement(
          'header',
          null,
          _react2.default.createElement(
            'h2',
            null,
            'Remove this timeline post?'
          ),
          _react2.default.createElement(
            'div',
            {
              className: 'feed-modal-close',
              onClick: this.props.onClose
            },
            _react2.default.createElement(_Close2.default, null)
          )
        ),
        body,
        _react2.default.createElement(
          'footer',
          null,
          _react2.default.createElement(_Uniform.Button, {
            onClick: this.props.onClose,
            style: 'subtle',
            text: 'Cancel'
          }),
          _react2.default.createElement(_Uniform.Button, {
            className: 'delete-button',
            icon: trashIcon,
            onClick: function onClick() {
              _this2.props.dismissFeedItem(feedItem.feedContentId);
            },
            status: status,
            style: 'destroy',
            text: 'Delete Post'
          })
        )
      );
    }
  }]);

  return ConfirmDismissFeedItem;
}(_react2.default.Component);

ConfirmDismissFeedItem.propTypes = {
  dismissFeedItem: _react.PropTypes.func.isRequired,
  feedItem: _react.PropTypes.shape({
    feedContentId: _react.PropTypes.string,
    isError: _react.PropTypes.bool,
    isRequesting: _react.PropTypes.bool
  }),
  onClose: _react.PropTypes.func.isRequired
};
exports.default = ConfirmDismissFeedItem;